export default "__VITE_ASSET__DoGs47hq__"